import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Modal as ReactModal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";

const propTypes = {
  isOpen: PropTypes.bool.isRequired,
  openCloseModal: PropTypes.func.isRequired
};

function GeoModal(props) {
  const { isOpen, openCloseModal } = props;

  const toggle = () => {
    openCloseModal(!isOpen);
  };

  return (
    <ReactModal centered isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Location Restricted</ModalHeader>
      <ModalBody>
        <div
          style={{
            paddingTop: "1rem",
            paddingBottom: "1rem"
          }}
        >
          <p>
            Your location is restricted from viewing this event. if you think
            this is an error, please enable Location services in your browser.
          </p>
          <br />
          <p>
            For more information go to&nbsp;
            <a
              href="https://help.prestosports.com/PrestoStream/v1/"
              target="_blank"
              rel="noreferrer"
            >
              PrestoStream Support
            </a>
          </p>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button onClick={toggle}>Close</Button>
      </ModalFooter>
    </ReactModal>
  );
}

GeoModal.propTypes = propTypes;

export default GeoModal;
